var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row"},[_c('strong',{staticClass:"d-flex pa-1 property-box-shadow flex-column w-50 justify-center"},[_vm._v("\n        "+_vm._s(_vm.property)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column ml-2 flex-grow-1 justify-center"},[_vm._v("\n        "+_vm._s(_vm.value)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }